// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__2UBUq","marketplaceStroke":"IconEmailAttention_marketplaceStroke__1t3n7","attentionStroke":"IconEmailAttention_attentionStroke__27jbL"};